import ApiTypes from "../types/apiTypes";
import { config } from "../../config/config";

export const pingRequest = () => ({
  type: ApiTypes.PING_REQUEST,
  http: {
    cognito: {
      effect: {
        url: `${(config as any).BASE_URL}/ping`,
        method: "GET"
      },
      commit: { type: ApiTypes.PING_SUCCESS },
      rollback: { type: ApiTypes.PING_FAILURE }
    }
  }
});

export const getUserInfoRequest = (username: string) => ({
  type: ApiTypes.GET_USER_INFO,
  username,
  http: {
    cognito: {
      effect: {
        url: `${(config as any).BASE_URL}/user/${username}`,
        method: "GET"
      },
      commit: { type: ApiTypes.GET_USER_INFO_SUCCESS },
      rollback: { type: ApiTypes.GET_USER_INFO_FAILURE }
    }
  }
});
